import VerticalProgramList from "./VerticalProgramList";

export default VerticalProgramList;
